export default "__VITE_ASSET__ewNeBrPD__"